module.exports = [{"name":"Despre noi","picture":"assets/images/asociatie.jpg","content":"Avem convingerea că toți putem fi mai buni, mai deschiși  către nevoile celorlalți, mai aproape unii de alții. Credem că împreună putem construi o lume mai frumoasă, mai bună, mai fericită. Asociația Umanitară „Dreptul la viață Huedin” își propune să transforme în realitate visuri, să aducă zâmbete, iar impreună să privim către un viitor mai bun.","motto":"Motto: „Căutând binele altora, îl găsim pe al nostru.” — Platon"}]


//////////////////
// WEBPACK FOOTER
// ./app/data/homePage.json
// module id = 218
// module chunks = 0